'use strict';

var icon = {};

exports.__exports = icon;
//# sourceMappingURL=icon2.cjs.map
